import { getModuleLoader } from "@/platform/_preload";

function __getBackendSpinnerContainer() {
    return document.querySelector(".spinner-container")
}

class SpinnerType {
    #body = null;
    #counter = 0;

    /**
     * @type HTMLElement
     */
    get __body() {
        return this.#body = ((!this.#body || this.#body.length==0 ) ? __getBackendSpinnerContainer() : this.#body);
    }

    __onlyIfHasBody(f) {
        if (!!this.__body) {
            f();
        }
    }

    __hideSpinner() {
        this.__body.classList.add("hidden");
    }

    __showSpinner() {
        this.__body.classList.remove("hidden");
    }

    hide_until(promise) {
        this.__onlyIfHasBody(() => {
            const counter = this.#counter;
            this.#counter = 0;
            this.hide();

            const display = () => {
                this.#counter += counter;
                if (this.#counter >= 0) this.__showSpinner();
            }
            promise.then(display, display);
        });
        return promise;
    }

    show() {
        this.__onlyIfHasBody(() => {
            if (this.#counter <= 0)
                this.__showSpinner();
                
            this.#counter += 1;
        });
    }

    hide() {
        this.__onlyIfHasBody(() => {
            this.#counter -= 1;
            if (this.#counter <= 0) {
                this.#counter = 0;
                this.__hideSpinner();
            }
        });
    }

    around(promise) {
        this.__onlyIfHasBody(() => {
            (async()=>{
                this.show();
                try {
                    await promise;
                } catch (e) {
                } finally {
                    this.hide();
                }
            })().then(()=>{}, (e) => window.reportError(e));
        });
        return promise;
    }

    wrap(func) {
        const _s = this;
        return function(...args) {
            return _s.around(func.apply(this, args));
        }
    }

    run(func) {
        return this.around(func());
    }
}

const Spinner = new SpinnerType;

globalThis["SpinnerWidget"] = Spinner;
getModuleLoader().module("widgets/v1/spinner", [], () => Spinner, false);
getModuleLoader().module("widgets/spinner", [], () => Spinner, false);

export default Spinner;
